import { Component } from '@angular/core';
import { ApiTokenService } from '../services/api-token.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-api-token-generate',
  templateUrl: './api-token-generate.component.html',
  styleUrls: ['./api-token-generate.component.scss'],
})
export class ApiTokenGenerateComponent {
  showInitialContent = true;
  description = '';

  constructor(
    private apiTokenService: ApiTokenService,
    public dialogRef: MatDialogRef<ApiTokenGenerateComponent>,
  ) {}

  generateNewToken() {
    this.apiTokenService.generateApiToken().subscribe({
      next: (response) => {
        if (response) {
          this.description = response;
          this.showInitialContent = false;
        }
      },
    });
  }

  close() {
    this.dialogRef.close();
  }

  copyToken() {
    if (this.description) {
      navigator.clipboard.writeText(this.description).then(() => {});
    }
  }
}
